import { render, staticRenderFns } from "./SecretOverlay.vue?vue&type=template&id=30797ff8"
import script from "./SecretOverlay.vue?vue&type=script&lang=js"
export * from "./SecretOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports